import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { PlusIcon } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
import { FAQS } from '../data/content';
export function Faq() {
  const [open, setOpen] = useState<number | null>(null);
  return <section className="bg-charcoal py-10 sm:py-12" aria-labelledby="faq-title" data-id="element-27" data-mp="1gd7iadgirj84">
      <div className="mx-auto max-w-3xl px-4 sm:px-6 lg:px-8" data-id="element-28" data-mp="2e0fwroi3rs0m">
        <SectionHeading title="Frequently Asked Questions" data-id="element-29" data-mp="2dzoeffdinqsa" />

        <ul className="mt-6 divide-y divide-line overflow-hidden rounded-lg border border-line bg-panel" data-id="element-30" data-mp="2913bv9askv0o">
          {FAQS.map((item, index) => {
          const isOpen = open === index;
          return <li key={item.q} data-id="element-31" data-mp="1z25i9ryiebat" data-mpi={index}>
                <h3 data-id="element-32" data-mp="1z59rx4uqtz8v">
                  <button type="button" onClick={() => setOpen(isOpen ? null : index)} aria-expanded={isOpen} aria-controls={`faq-panel-${index}`} className="flex w-full items-center justify-between gap-3 px-4 py-3 text-left transition-colors duration-150 ease-out hover:bg-cream/[0.03] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-gold sm:px-5 sm:py-3.5" data-id="element-33" data-mp="sn3heduptxkt">
                    <span className="text-[13.5px] font-semibold leading-snug text-cream sm:text-[15px]" data-id="element-34" data-mp="kibld2tgm7he">
                      {item.q}
                    </span>
                    <PlusIcon className={`h-4 w-4 shrink-0 text-gold transition-transform duration-200 ease-out ${isOpen ? 'rotate-45' : ''}`} aria-hidden="true" data-id="element-35" data-mp="6plo228hdg4z" />
                  </button>
                </h3>
                <AnimatePresence initial={false} data-id="element-36" data-mp="3jy8d7g1eik3e">
                  {isOpen ? <motion.div id={`faq-panel-${index}`} initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.22,
                ease: [0.23, 1, 0.32, 1]
              }} className="overflow-hidden" data-id="element-37" data-mp="3nzk3zow0hbd6">
                      <p className="px-4 pb-3.5 text-[12.5px] leading-snug text-mutedtext sm:px-5 sm:text-[14px]" data-id="element-38" data-mp="1fs883wunho0e">
                        {item.a}
                      </p>
                    </motion.div> : null}
                </AnimatePresence>
              </li>;
        })}
        </ul>
      </div>
    </section>;
}